export default "__VITE_ASSET__CpH2OcVg__"